export const newsData = [
    {
        id: 1,
        title: "Продление водительского\n" +
            "удостоверения в 2025 году",
        text: "Водителям, у которых заканчивался срок действия прав, продлили документ на три года — такая отсрочка существенно упростила жизнь многим автолюбителям в 2022 году...",
        date: "11.02.2025"
    },
    {
        id: 2,
        title: "Продление водительского\n" +
            "удостоверения в 2025 году",
        text: "Водителям, у которых заканчивался срок действия прав, продлили документ на три года — такая отсрочка существенно упростила жизнь многим автолюбителям в 2022 году...",
        date: "11.02.2025"
    },
    {
        id: 3,
        title: "Продление водительского\n" +
            "удостоверения в 2025 году",
        text: "Водителям, у которых заканчивался срок действия прав, продлили документ на три года — такая отсрочка существенно упростила жизнь многим автолюбителям в 2022 году...",
        date: "11.02.2025"
    },
    {
        id: 4,
        title: "Продление водительского\n" +
            "удостоверения в 2025 году",
        text: "Водителям, у которых заканчивался срок действия прав, продлили документ на три года — такая отсрочка существенно упростила жизнь многим автолюбителям в 2022 году...",
        date: "11.02.2025"
    },
]